import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Group, Stack, Text } from '@mantine/core';
import { useHistory } from 'react-router-dom';
import { Context as EcommerceContext } from '../../../providers/EcommerceProvider';
import PaginationList from '../../common/PaginationList';
import ActionListItem from '../../common/ActionListItem';
import EcomStoreAdminModal from './EcomStoreAdminModal';

const EcomStoreAdminListView = ({ ecomStore }) => {
  const history = useHistory();
  const { state, fetchEcomStoreAdmins } = useContext(EcommerceContext);
  const [pageState, setPageState] = useState({
    activePageIndex: 1,
    inactivePageIndex: 1
  });
  const [adminModalState, setAdminModalState] = useState({
    isOpen: false,
    action: '',
    ecomVendorAdmin: null
  });
  const ecomStoreAdmins = state.ecomStoreAdmins.value
    .filter((a) => a.user && a.fkEcomStore === ecomStore.pkEcomStore)
    .sort((a, b) => a.user.name.localeCompare(b.user.name));
  const deletedAdmins = ecomStoreAdmins.filter((a) => a.deleted);

  useEffect(() => {
    if (ecomStore) {
      fetchEcomStoreAdmins(ecomStore.pkEcomStore);
    }
  }, [ecomStore]);

  return (
    <Stack sx={{ gap: 20, marginTop: 20 }}>
      <Stack sx={{ gap: 5 }}>
        <Group sx={{ flex: 1, justifyContent: 'space-between' }}>
          <Text weight={500}>Active Admins</Text>
          <Button
            color="green"
            compact
            onClick={() => {
              setAdminModalState({
                isOpen: true,
                action: 'ADD',
                ecomVendorAdmin: null
              });
            }}
          >
            Add Admin
          </Button>
        </Group>
        <PaginationList
          emptyMessage="No admins assigned"
          isLoading={state.ecomStoreAdmins.loading}
          items={ecomStoreAdmins
            .filter((a) => !a.deleted)
            .map((a) => (
              <ActionListItem
                key={a.pkEcomStoreAdmin}
                actions={[
                  {
                    label: 'Remove',
                    color: 'red',
                    value: 'REMOVE'
                  }
                ]}
                avatar={a.user.avatar}
                description={a.user.email}
                header={a.user.name}
                onAction={(action) =>
                  setAdminModalState({
                    isOpen: true,
                    action,
                    ecomStoreAdmin: a
                  })
                }
                onClick={() => {
                  history.push(`/users/${a.user.pkUser}`);
                }}
                showImage
              />
            ))}
          itemsPerPage={10}
          LoadingComponent={ActionListItem}
          onPageChange={(index) =>
            setPageState({
              ...pageState,
              activePageIndex: index
            })
          }
          pageIndex={pageState.activePageIndex}
          showItemBorder
        />
      </Stack>

      {deletedAdmins.length === 0 ? (
        <></>
      ) : (
        <Stack sx={{ gap: 5 }}>
          <Group>
            <Text weight={500}>Disabled Admins</Text>
          </Group>
          <PaginationList
            isLoading={state.ecomStoreAdmins.loading}
            items={deletedAdmins.map((a) => (
              <ActionListItem
                key={a.pkEcomStoreAdmin}
                actions={[
                  {
                    label: 'Restore',
                    color: 'green',
                    value: 'RESTORE'
                  }
                ]}
                avatar={a.user.avatar}
                description={a.user.email}
                header={a.user.name}
                onAction={(action) =>
                  setAdminModalState({
                    isOpen: true,
                    action,
                    ecomStoreAdmin: a
                  })
                }
                onClick={() => {
                  history.push(`/users/${a.user.pkUser}`);
                }}
                showImage
              />
            ))}
            itemsPerPage={10}
            LoadingComponent={ActionListItem}
            onPageChange={(index) =>
              setPageState({
                ...pageState,
                inactivePageIndex: index
              })
            }
            pageIndex={pageState.inactivePageIndex}
          />
        </Stack>
      )}
      <EcomStoreAdminModal
        action={adminModalState.action}
        ecomStore={ecomStore}
        ecomStoreAdmin={adminModalState.ecomStoreAdmin}
        isOpen={adminModalState.isOpen}
        onClose={() =>
          setAdminModalState({
            ...adminModalState,
            isOpen: false
          })
        }
        onSuccess={() => {
          setAdminModalState({
            ...adminModalState,
            isOpen: false
          });
          fetchEcomStoreAdmins(ecomStore.pkEcomStore);
        }}
      />
    </Stack>
  );
};

EcomStoreAdminListView.propTypes = { ecomStore: PropTypes.object };

export default EcomStoreAdminListView;
